// extracted by mini-css-extract-plugin
module.exports = {"field":"SpecialScopesForm_field__KDbp4"};